import axios from "axios";
import { localStorageItem } from './../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from '../../models/OctResponse';
import { urlParamsConfig } from "../../utils/ParamsUtils";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_KET_NOI = API + "/config";
const API_CAU_HINH_PHAN_MEM = API + "/c-system-org";

export const addKn = (data: any) => {
  let url = API_KET_NOI;
  return axios.post(url, data);
};

export const searchDanhSachKn = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_KET_NOI}` + `/search`;
  return axios.post(url, searchData)
};

export const searchDanhSachPhanMem = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_CAU_HINH_PHAN_MEM}` + `/search`;
  return axios.post(url, searchData)
};

export const detailKn = (id: string) => {
  const url = `${API_KET_NOI}` + `/${id}`;
  return axios.get(url);
};

export const deleteKn = (id: string) => {
  const url = `${API_KET_NOI}` + `/${id}`;
  return axios.delete(url);
};